import PropTypes from 'prop-types'
import React from 'react'

const Panel = ({ steps, currentStep }) => {
  const stepNumber = steps.indexOf(currentStep)

  const stepStateClass = (panelIndex) => {
    return stepNumber >= panelIndex ? ' active' : ''
  }

  const panelSteps = () => {
    return steps.map((step, i) => {
      const stateClass = stepStateClass(i)

      return <div className={'panel-step' + ` steps-${steps.length}` + stateClass} key={i}>
        <div className={'step-number' + stateClass}>
          {`STEP ${i + 1}`}
        </div>
        <div className='step-name'>{step}</div>
      </div>
    })
  }

  return <div className='registration-panel'>
    {panelSteps()}
  </div>
}

Panel.propTypes = {
  steps: PropTypes.array.isRequired,
  currentStep: PropTypes.string.isRequired,
}

export default Panel
